export const TEMPLATES = [
	{
		id: "1",
		name: "Basic Template",
		description: "Basic template for a course",
		json: {
			Content: [
				{
					id: 1,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: 646.265625, y: -533.19287109375 },
					phaseName: "Willkommen! ",
					timeLimit: 600,
					contentType: "TEXT",
					decisionName: "Sind Sie vollzählig? ",
					phaseEndText: "",
					phaseEndResult: "Success",
					decisionOptions: [{ option: "Ja, Fortfahren", phaseId: 2 }],
					timeDelayedContent: [],
					timeLeftDecisionId: 2,
					confirmationRequired: "FROM_ALL",
				},
				{
					id: 2,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: 647.7092965152781, y: -260.8435492923186 },
					phaseName: "Lageentwicklung",
					timeLimit: 400,
					contentType: "TEXT",
					decisionName: "Wie gehen Sie mit diesen Meldungen um? ",
					phaseEndText: "",
					phaseEndResult: "Success",
					spoilerContent: {
						title: "Hinweis",
						content:
							"Lieferkettenunterbrechungen dieser Größenordnung sind niemals nur logistische Probleme; sie sind komplexe Unternehmenskrisen mit weitreichenden finanziellen, personellen und reputativen Folgen. Jüngste Krisen haben gezeigt, dass Produktions- oder Dienstleistungsstopps direkt zu Kurzarbeit, massiven Umsatzeinbußen und Vertragsstrafen führen können. Ein rein operativ besetzter Stab ist nicht in der Lage, diese Kaskadeneffekte adäquat zu bewerten. Etablierte BCM-Standards betonen daher die Notwendigkeit einer vordefinierten, interdisziplinären Bewältigungsorganisation (BAO). ",
					},
					decisionOptions: [
						{
							option:
								"Wir fragen sofort beim Hafen an und versuchen detaillierte Informationen zu erhalten",
							phaseId: 3,
						},
						{ option: "Wir warten erstmal ab ob uns dieser Vorfall tangiert. ", phaseId: 5 },
					],
					timeDelayedContent: [],
					timeLeftDecisionId: 5,
					confirmationRequired: "FROM_ALL",
				},
				{
					id: 3,
					content: null,
					effects: [],
					autoplay: false,
					position: { x: 92.10020294830622, y: 93.09401854928764 },
					phaseName: "E-Mail vom Hamburger Hafen. ",
					timeLimit: 600,
					contentType: "IMAGE",
					decisionName: "Wie wollen Sie vorgehen? ",
					phaseEndText: "",
					phaseEndResult: "Success",
					decisionOptions: [
						{
							option:
								"Wir berufen den vollständigen Notfallstab ein.  Alle im Notfallplan vordefinierten Mitglieder, einschließlich Vertreter aus Kommunikation, HR, Finanzen und Recht, werden sofort und vollumfänglich einberufen.",
							phaseId: 4,
						},
						{
							option:
								"Wir berufen nur ein operatives Team mit Logistik, Operations und Einkauf ein. Wir müssen nicht unnötig Ressourcen binden. ",
							phaseId: 6,
						},
					],
					timeDelayedContent: [],
					timeLeftDecisionId: 6,
					confirmationRequired: "FROM_ALL",
				},
				{
					id: 4,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: 97.19263835825322, y: 515.6266513812545 },
					phaseName: "Erarbeiten sie einen Lagevortrag zur Unterrichtung. ",
					contentType: "TEXT",
					decisionName: "Ist der Vortrag abgeschlossen? ",
					phaseEndText: "",
					phaseEndResult: "Success",
					spoilerContent: {
						title: "Zielsetzung",
						content:
							"Erstellung eines qualifizierten, gemeinsamen Lagebildes (Common Relevant Operating Picture), Durchführung einer Ad-hoc Business Impact Analyse (BIA) und Festlegung der strategischen Ziele für die Krisenbewältigung.",
					},
					decisionOptions: [{ option: "Ja, weiter zur nächsten Sequenz.", phaseId: 14 }],
					timeDelayedContent: [],
					timeLeftDecisionId: null,
					confirmationRequired: "FROM_ALL",
				},
				{
					id: 5,
					content: null,
					effects: [],
					autoplay: false,
					position: { x: 1147.352978860097, y: 27.2406981867896 },
					phaseName: "E-Mail vom Hamburger Hafen ",
					timeLimit: 500,
					contentType: "IMAGE",
					decisionName: " Ausruf Notfall und Einberufung Notfallstab",
					phaseEndText: "",
					phaseEndResult: "Success",
					decisionOptions: [
						{
							option:
								"Wir berufen nur ein operatives Team mit Logistik, Operations und Einkauf ein. Wir müssen nicht unnötig Ressourcen binden. ",
							phaseId: 6,
						},
						{
							option:
								"Wir berufen den vollständigen Notfallstab ein.  Alle im Notfallplan vordefinierten Mitglieder, einschließlich Vertreter aus Kommunikation, HR, Finanzen und Recht, werden sofort und vollumfänglich einberufen.",
							phaseId: 8,
						},
					],
					timeLeftDecisionId: 6,
					confirmationRequired: "FROM_ALL",
				},
				{
					id: 6,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: 1302.8696843854607, y: 448.558818991472 },
					phaseName: "Anfrage der Presse",
					timeLimit: 400,
					contentType: "TEXT",
					decisionName: "Wie wollen Sie mit der Frage umgehen? ",
					phaseEndText: "",
					phaseEndResult: "Success",
					decisionOptions: [
						{
							option: "Wir erweitern umgehend den Notfallstab und nutzen die Expertise.",
							phaseId: 8,
						},
						{
							option:
								"Wir antworten, dass wir alles tun um das zu vermeiden aber zu diesem Zeitpunkt nichts ausschließen können. ",
							phaseId: 11,
						},
					],
					timeLeftDecisionId: 8,
					confirmationRequired: "FROM_ALL",
				},
				{
					id: 8,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: 767.9807393191846, y: 573.9803684677703 },
					phaseName: "Erarbeiten sie einen Lagevortrag zur Unterrichtung ",
					contentType: "TEXT",
					decisionName: "Ist der Vortrag abgeschlossen? ",
					phaseEndText: "",
					phaseEndResult: "Success",
					spoilerContent: {
						title: "Hinweis: ",
						content:
							"Zielsetzung: Erstellung eines qualifizierten, gemeinsamen Lagebildes (Common Relevant Operating Picture), Durchführung einer Ad-hoc Business Impact Analyse (BIA) und Festlegung der strategischen Ziele für die Krisenbewältigung.",
					},
					decisionOptions: [{ option: "Ja, weiter mit der nächsten Sequenz. ", phaseId: 14 }],
					timeDelayedContent: [],
					confirmationRequired: "NONE",
				},
				{
					id: 10,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: 436.98638216067025, y: 1182.3809349992262 },
					phaseName: "Absprache mit der Unternehmensleitung ",
					timeLimit: 600,
					contentType: "TEXT",
					decisionName: "Geben Sie eine Empfehlung! ",
					phaseEndText: "",
					phaseEndResult: "Success",
					spoilerContent: {
						title: "Hinweis ",
						content:
							"Die offensichtlichste Lösung ist nicht immer die beste. Die Logistikalternativen sind komplex: Luftfracht ist schnell, aber extrem teuer und kapazitätsbeschränkt. Seefracht ist kostengünstig, aber langsam und im Krisenfall unflexibel",
					},
					decisionOptions: [
						{
							option:
								"Luftfracht-Option: Das Angebot wird angenommen, um die Betriebsunterbrechung zu minimieren, trotz der extremen Kosten",
							phaseId: 7,
						},
						{
							option:
								"Alternativhafen-Option: Das Angebot wird abgelehnt. Stattdessen wird alles auf die Umleitung eines anderen Schiffes nach Rotterdam gesetzt, das in 5 Tagen ankommen könnte. Dies bedeutet eine sichere Betriebsunterbrechung von 2 Tagen, spart aber die hohen Kosten der Luftfracht.",
							phaseId: 12,
						},
						{
							option:
								" Akzeptanz des Stillstands: Das Angebot wird abgelehnt. Es wird ein 14-tägiger Stillstand in Kauf genommen, um Kosten zu maximieren und auf die Bergung des Schiffes zu warten.",
							phaseId: 13,
						},
					],
					timeDelayedContent: [],
					timeLeftDecisionId: 7,
					confirmationRequired: "FROM_ALL",
				},
				{
					id: 11,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: 1303.4206942107544, y: 764.2497997165059 },
					phaseName: "Meldung Betriebsrat ",
					contentType: "TEXT",
					phaseEndText:
						"Die Übung ist fehlgeschlagen. Achten sie auf proaktives aber koordiniertes Vorgehen während Ihrer Stabsarbeit! ",
					phaseEndResult: "Failed",
					timeDelayedContent: [],
				},
				{
					id: 7,
					content: null,
					effects: [],
					autoplay: false,
					position: { x: 18.950979842392087, y: 1449.1203644799457 },
					phaseName: "Luftfrachtoption ",
					timeLimit: 500,
					contentType: "TEXT",
					decisionName: "Wie gehen Sie mit dem Angebot um? ",
					phaseEndText: "",
					phaseEndResult: "Success",
					decisionOptions: [
						{
							option:
								"Um den Betrieb so schnell wie möglich zumindest teilweise wieder anlaufen zu lassen, wird das extrem teure Angebot angenommen, ohne die Ergebnisse der Arbeitsgruppen abzuwarten.",
							phaseId: 15,
						},
						{
							option:
								"Der Stab nutzt das Zeitfenster von 4 Stunden und nimmt sich 2 Stunden Zeit, um die Berichte der Arbeitsgruppen abzuwarten und eine abgewogene Entscheidung auf einer breiteren Informationsbasis zu treffen.",
							phaseId: 18,
						},
					],
					timeDelayedContent: [],
					timeLeftDecisionId: 15,
					confirmationRequired: "FROM_ALL",
				},
				{
					id: 12,
					content: null,
					effects: [],
					autoplay: false,
					position: { x: 609.4666563081644, y: 1432.8791246983787 },
					phaseName: "Neues Schiff mit Alternativroute über Rotterdam ",
					timeLimit: 120,
					contentType: "TEXT",
					decisionName:
						"Es ist nicht sicher, dass das funktioniert. Wollen Sie doch lieber den Flugzeugdeal, bevor es zu spät ist?",
					phaseEndText: "",
					phaseEndResult: "Success",
					decisionOptions: [
						{ option: "Weiter mit der Umleitung nach Rotterdam.", phaseId: 17 },
						{ option: "Weiter mit dem Flugzeugdeal. ", phaseId: 18 },
					],
					timeDelayedContent: [],
					timeLeftDecisionId: 13,
					confirmationRequired: "FROM_ALL",
				},
				{
					id: 13,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: 664.0671829437189, y: 2533.134507880658 },
					phaseName: "Akzeptanz des Stillstandes ",
					contentType: "TEXT",
					phaseEndText:
						"Eine strategisch hochgradig fragwürdige Entscheidung, die massive finanzielle Schäden und einen erheblichen Reputationsverlust nach sich zieht. ",
					phaseEndResult: "Failed",
					timeDelayedContent: [],
				},
				{
					id: 14,
					content: null,
					effects: [],
					autoplay: false,
					position: { x: 433.55895221656624, y: 917.7252970658142 },
					phaseName: "Angebot des Lieferanten ",
					timeLimit: 200,
					contentType: "IMAGE",
					decisionName: "Weiter mit der nächsten Sequenz: ",
					phaseEndText: "",
					phaseEndResult: "Success",
					decisionOptions: [{ option: "Fortfahren ", phaseId: 10 }],
					timeDelayedContent: [],
					timeLeftDecisionId: 10,
					confirmationRequired: "FROM_ALL",
				},
				{
					id: 15,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: -392.5973381408522, y: 1706.5223787072955 },
					phaseName: "Anruf der Finanzabteilung ",
					contentType: "TEXT",
					phaseEndText:
						"Die Übung ist fehlgeschlagen. Achten sie auf proaktives aber koordiniertes Vorgehen während Ihrer Stabsarbeit! ",
					phaseEndResult: "Failed",
					timeDelayedContent: [],
				},
				{
					id: 17,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: 865.2621010920544, y: 1731.05107362915 },
					phaseName: "Anruf aus Rotterdam ",
					contentType: "TEXT",
					decisionName:
						"Hafen Rotterdam meldet extreme Überlastung durch umgeleitete Schiffe aus Hamburg. Aktuelle Wartezeit für unplanmäßige Anläufe beträgt 6 Tage, nicht wie erhofft 3. Ihr Schiff liegt auf Reede.",
					phaseEndText: "",
					phaseEndResult: "Success",
					decisionOptions: [
						{
							option:
								"Das Management übt massiven Druck auf den Lieferanten aus und fordert unter Verweis auf die langjährige Partnerschaft eine sofortige Lösung.",
							phaseId: 20,
						},
						{
							option:
								"Der Stab akzeptiert die Verzögerung als Konsequenz der Marktsituation, informiert umgehend die Betriebsplanung und beginnt sofort mit der Umplanung, um den neuen Engpass zu managen.",
							phaseId: 24,
						},
					],
					timeDelayedContent: [],
					confirmationRequired: "FROM_ALL",
				},
				{
					id: 18,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: 63.666229110722014, y: 1823.3511616412727 },
					phaseName: "Anruf aus dem Einkauf ",
					timeLimit: 1900,
					contentType: "TEXT",
					decisionName:
						"Erarbeiten sie eine Alternative Lösung, welche sie der Geschäftsführung und dem Vorstand präsentieren können. ",
					phaseEndText: "",
					phaseEndResult: "Success",
					decisionOptions: [
						{ option: "Es wurde eine Alternative entwickelt und protokolliert! ", phaseId: 16 },
						{ option: "Wir entschließen uns, den Lieferausfall hinzunehmen", phaseId: 13 },
					],
					timeDelayedContent: [],
					timeLeftDecisionId: 13,
					confirmationRequired: "FROM_ALL",
				},
				{
					id: 16,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: 241.1525781461704, y: 2492.7186225944106 },
					phaseName: "ERFOLG! ",
					contentType: "TEXT",
					phaseEndText: "Herzlichen Glückwunsch! ",
					phaseEndResult: "Success",
					timeDelayedContent: [],
				},
				{
					id: 20,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: 1059.3587421076293, y: 2506.8439722680423 },
					phaseName: "Fehlschlag! ",
					contentType: "TEXT",
					phaseEndText:
						"Krisen sind selten singuläre, isolierte Ereignisse. Vielmehr lösen sie oft Kaskadeneffekte aus, bei denen die Lösung eines Problems ein neues, unerwartetes Problem schafft. Dies ist ein zentrales Element im Design anspruchsvoller Krisenübungen. Denken sie stets lösungsorientiert, nicht problemorientiert.",
					phaseEndResult: "Failed",
					timeDelayedContent: [],
				},
				{
					id: 24,
					content: null,
					effects: [],
					autoplay: true,
					position: { x: 721.5850203478435, y: 1958.393731057213 },
					phaseName: "Neue Wege ",
					timeLimit: 1800,
					contentType: "TEXT",
					decisionName:
						"Erarbeiten sie eine Alternative Lösung, welche sie der Geschäftsführung und dem Vorstand präsentieren können. ",
					phaseEndText: "",
					phaseEndResult: "Success",
					decisionOptions: [
						{ option: "Wir entschließen uns, den Lieferausfall hinzunehmen", phaseId: 13 },
						{ option: "Es wurde eine Alternative entwickelt und protokolliert! ", phaseId: 16 },
					],
					timeDelayedContent: [],
					timeLeftDecisionId: 13,
					confirmationRequired: "FROM_ALL",
				},
			],
			scenarioName: "Basic Template",
		},
	},
];
